import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck } from '@fortawesome/pro-solid-svg-icons/faCheck';
import { faQuestionCircle } from '@fortawesome/pro-solid-svg-icons/faQuestionCircle';
import { faSync } from '@fortawesome/pro-solid-svg-icons/faSync';

import React from 'react';

import messages from '../../messages';
import style from '../style.module.less';

export const emailVerificationStatusMap = {
  Verified: {
    value: 'Verified',
    icon: <FontAwesomeIcon className={style['verify-email-icon']} icon={faCheck} />,
    message: messages.alreadyVerified,
  },
  Unverified: {
    value: 'Unverified',
    icon: <FontAwesomeIcon className={style['verify-email-icon']} icon={faQuestionCircle} />,
    message: messages.verifyEmailLink,
  },
  Pending: {
    value: 'Pending',
    icon: <FontAwesomeIcon className={style['verify-email-icon']} icon={faSync} />,
    message: messages.resendVerificationLink,
  },
};
